module.exports = __webpack_public_path__ + "img/law-serve-nav-icon07.36de81b2.png";